import { render, staticRenderFns } from "./ControlpanelMenu.vue?vue&type=template&id=f86a30a2&"
import script from "./ControlpanelMenu.vue?vue&type=script&lang=js&"
export * from "./ControlpanelMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports